import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ItemChanged } from './../../../interfaces/item-changed.interface';
import { OptionItem } from '../../interfaces/option-item.interface';
import { QUICK_QUOTE_CONSTANTS } from '../../../quick-quote/quick-quote.constants';

@Component({
    selector: 'dcl-option-item',
    templateUrl: './option-item.component.html',
    styleUrls: ['./option-item.component.scss']
})
export class OptionItemComponent {
    @Input() option: OptionItem;
    @Input() isLastOption: boolean;
    @Input() isLastGroup: boolean;
    @Input() optionGroupLabel: string;
    @Output() onItemChanged: EventEmitter<ItemChanged> = new EventEmitter();
    @Output() lastItemTabbed = new EventEmitter<KeyboardEvent>();

    constants = QUICK_QUOTE_CONSTANTS;

    /**
     * Toggles check active
     * @param  option option selected
     * @param  event
     */
    toggleCheck(option: OptionItem, event: Event): void {
        if (!option.disabled) {
            option.selected = !option.selected;
            this.onItemChanged.emit({
                id: option.id,
                isSelected: option.selected,
                urlFriendlyId: option.urlFriendlyId
            });

            event.preventDefault();
        }
    }

    /**
     * Handles tab key press event
     * @param event Keyboard event
     */
    onTabPress(event: KeyboardEvent): void {
        if (this.isLastGroup && this.isLastOption) {
            this.lastItemTabbed.emit(event);
        }
    }
}
